import { render, staticRenderFns } from "./short-link-form.vue?vue&type=template&id=2fc7681a&scoped=true&"
import script from "./short-link-form.vue?vue&type=script&lang=js&"
export * from "./short-link-form.vue?vue&type=script&lang=js&"
import style0 from "./short-link-form.vue?vue&type=style&index=0&id=2fc7681a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7681a",
  null
  
)

export default component.exports